module.exports = __webpack_public_path__ + "static/media/sea-tex.aef3e280.jpg";